export default __webpack_public_path__ + "static/media/TMZ.33eed1ce.svg";